export default {
  update: (state, data) => ({
    ...state,
    ...data,
  }),
  reset: (state) => ({
    ...state,
  }),
}
